export const getEstado = _class => {
  if (_class === 'LEAD') return 'Lead'
  if (_class === 'LEAD_NO_VALIDO') return 'Lead no valido'
  if (_class === 'LEAD_DERIVADO') return 'Lead Derivado'
  if (_class === 'PRUEBA') return 'Prueba'
  if (_class === 'LEAD_CUALIFICADO') return 'Lead cualificado'
  if (_class === 'CLIENTE_CAPTADO') return 'Cliente Captado'
  if (_class === 'CLIENTE_PERDIDO') return 'Cliente Perdido'
}
